// Fieldline-tracing intent handlers.

import { INTENTS } from '@store/intents';
import { params } from '@store/instance';
import {
    traceFromSelection as flTraceFromSelection,
    clearAll as flClearAll,
    applyDisplay as flApplyDisplay,
} from '@scene/fieldlines';
import type { Store } from '@store/store';
import type { State } from '@store/schema';
import type { ViewerContext } from '../context';

export function register(store: Store<State>, viewer: ViewerContext): Array<() => void> {
    const offs: Array<() => void> = [];

    offs.push(store.onIntent(INTENTS.TRACE_FIELDLINE, () => flTraceFromSelection(viewer, params)));
    offs.push(store.onIntent(INTENTS.CLEAR_FIELDLINES, () => flClearAll(viewer)));

    offs.push(store.onIntent(INTENTS.SET_FIELDLINE_DISPLAY, (p) => {
        flApplyDisplay(viewer, params, { rebuildGeometry: !!(p && p.rebuildGeometry) });
    }));

    offs.push(store.onIntent(INTENTS.SET_FIELDLINES_VISIBILITY, (p) => {
        if (!p) return;
        const v = !!p.visible;
        params.showFieldLines = v;
        viewer.objects.fieldlines.lines.forEach((group) => { group.visible = v; });
        store.dispatch(INTENTS.UI_PANE_REFRESH);
    }));

    return offs;
}
